// extracted by mini-css-extract-plugin
export default {"root":"card_root__6X8+M","playButton":"card_playButton__cqW2C","playButtonTriangle":"card_playButtonTriangle__sw6qY"};